module.exports = __webpack_public_path__ + "img/thumbnail_RingTailedLemur_j_albino.4f618415.png";